module.exports = __webpack_public_path__ + "img/b_immun_3.e3f3a27b.jpeg";